<template>
  <div class="chat-container w-100 position-relative bg-light-page hide-scroll overflow-scroll" style="height: 100vh">
    <span id="payment"></span>
    <div class="bg-green">
      <div class="w-100">
        <div class="row w-100">
          <router-link :to="'/'+getMerchant().code+'/cart'">
            <div class="col-1">
              <div class="nav-back" style="top: 15px!important;left: 15px!important;">
                <img src="../../assets/img/icon/back-white.png" width="20">
              </div>
            </div>
          </router-link>
          <div class="col-10 py-14px">
            <p class="text-white heading-6 mb-0">Payment Process</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container bg-green pb-4 pt-1">
      <div class="row slim-grid-row pb-1">
        <div class="col-12 text-center">
          <p class="mb-0 text-green d-inline-block body-2-4 bg-white text-center circle-cart bg-green-opacity">1</p>
          <p class="mb-0 text-white d-inline-block body-3-3-3 ml-1 opacity-45">Book</p>
          <p class="mb-0 d-inline-block text-white opacity-45 ml-1 desh-cart">___</p>
          <p class="mb-0 text-green d-inline-block body-2-4 bg-white text-center circle-cart ml-1">2</p>
          <p class="mb-0 text-white d-inline-block body-3-3-3 ml-1 ">Pay</p>
          <p class="mb-0 d-inline-block text-white opacity-45 ml-1 opacity-45 desh-cart">___</p>
          <p class="mb-0 text-green d-inline-block body-2-4 bg-white text-center circle-cart ml-1 bg-green-opacity">3</p>
          <p class="mb-0 text-white d-inline-block body-3-3-3 ml-1 opacity-45">Voucher</p>
        </div>
      </div>
    </div>
    <loader v-if="is_load" />
    <div v-else class="container mt-0 pb-4 bg-light-page" >
      <div class="bg-white box-shadow-bold rounded-10 mb-4 mt-3">
        <div class="px-4 py-3">
          <doku-form v-if="order_detail.payment_details.payment_method == 'CREDIT_CARD' && order_detail.payment_details.bank_name == 'DOKU'"></doku-form>
          <qris-form :data="order_detail.payment_details.payment_gateway_response" v-if="!isPivotPayment && order_detail.payment_details.payment_method == 'QRIS'" />
          <virtual-account-form :tx_date="order_detail.transaction_date" :payment_detail="order_detail.payment_details" :data="order_detail.payment_details.payment_gateway_response" :channel="order_detail.payment_details.payment_channel" v-if="!isPivotPayment && order_detail.payment_details.payment_method == 'VIRTUAL_ACCOUNT'"  />
        </div>
      </div>
      <div class="bg-white box-shadow-bold rounded-10 mb-4 mt-3" v-if="order_detail.payment_details.payment_method != 'CREDIT_CARD' || isJokulCreditCardPending || isPivotPaymentPending">
        <div class="px-4 py-3 text-center">
          <div v-if="isJokulCreditCardPending" @click="openJokulCheckout()" class="rounded-6 px-4 py-3 text-center mb-3" :class="{'bg-green cursor-pointer': !is_opening_jokul_checkout, 'bg-green-disabled cursor-disable' : is_opening_jokul_checkout}">
            <p class="text-white body-15 mb-0 ls-1-25">{{$t('hotel.action.continue-payment')}}</p>
          </div>
          <div v-if="isPivotPaymentPending" @click="$openLink(pivotPaymentUrl)" class="rounded-6 px-4 py-3 text-center mb-3 bg-green cursor-pointer">
            <p class="text-white body-15 mb-0 ls-1-25">Complete Payment</p>
          </div>
          <p class="body-2-4 mb-3">
            Sudah Melakukan Pembayaran ?
          </p>
          <div @click="checkPaymentStatus" class="rounded-6 px-4 py-3 text-center mb-2" :class="{'bg-green cursor-pointer': !btn_is_load, 'bg-green-disabled cursor-disable' : btn_is_load}">
            <pulse-loader :loading="btn_is_load" v-if="btn_is_load"></pulse-loader>
            <p class="text-white body-15 mb-0 ls-1-25" v-else>Cek Status Pembayaran</p>
          </div>
          <p v-if="error" class="body-2-4 mb-3 text-danger">
            Tiket masih belum terbayar
          </p>
        </div>
      </div>
    </div>
    <div class="pb-5"></div>
  </div>
</template>
<script>
  import QrisForm from '@/components/ticket/QrisForm';
  import DokuForm from '@/components/ticket/DokuForm';
  import VirtualAccountForm from '@/components/ticket/VirtualAccountForm';
  import {mapGetters} from "vuex";
  import {get,post} from '@/services/index.js';
  import moment from 'moment';
  import {formatCurrency,formatDate,checkDataExist} from '@/utils/index.js';
  export default {
    components: {
      DokuForm,
      QrisForm,
      VirtualAccountForm
    },
    metaInfo(){
      return {
        title: 'Payment',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        is_load: true,
        order_detail: {},
        error: false,
        btn_is_load: false,
        tx_detail: {},
        has_opened_jokul_checkout: false,
        is_opening_jokul_checkout: false
      }
    },
    computed:{
      jokulCheckoutUrl(){
        const payment_details = this.order_detail.payment_details;
        if(!payment_details) return '';
        if(!this.$isJokulCreditCard(payment_details.bank_name, payment_details.payment_method)) return '';

        // Bentuk response PG yang disimpan BE berbeda antar channel, jadi URL dicari di ketiga lokasi
        const pg_response = payment_details.payment_gateway_response || {};
        return payment_details.url || pg_response.url || (pg_response.payment && pg_response.payment.url) || '';
      },
      isJokulCreditCardPending(){
        return this.order_detail.status == 'WAITING_PAYMENT_CONFIRMATION' && this.jokulCheckoutUrl !== '';
      },
      isPivotPayment(){
        const payment_details = this.order_detail.payment_details;
        return Boolean(payment_details) && this.$isPivotPayment(payment_details.bank_name);
      },
      pivotPaymentUrl(){
        if(!this.isPivotPayment) return '';
        const payment_details = this.order_detail.payment_details;
        return this.$getPivotPaymentUrl(payment_details) || this.$getPivotPaymentUrl(payment_details.payment_gateway_response);
      },
      isPivotPaymentPending(){
        return this.order_detail.status == 'WAITING_PAYMENT_CONFIRMATION' && this.pivotPaymentUrl !== '';
      }
    },
    mounted(){
      document.getElementById('payment').scrollIntoView({
          behavior: 'smooth'
      });
      this.getOderDetail()
    },
    methods: {
      ...mapGetters(['getTicketCart', 'getMerchant','getTicketCartSubTotal','getTicketPayment','getMetaTitleTemplate']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
      getOderDetail(){
        this.is_load = true
        get("CORE","tx-ticket-detail/"+this.$route.params.tx_order_id).then(response=>{
          let res = response.data
          if (res.success) {
            this.order_detail = res.data
            this.autoOpenJokulCheckout()
            if(res.data.status == 'COMPLETE'){
              // this.$router.push({
              //   path:'/'+this.getMerchant().code+'/payment-result/'+res.data.tx_order_id
              // })
              this.checkPaymentStatus(false)
            }
          }
          this.is_load = false
        })
      },
      // Popup Jokul dibuka sekali saja per kunjungan; refetch status tidak boleh membukanya lagi
      autoOpenJokulCheckout(){
        if(!this.isJokulCreditCardPending || this.has_opened_jokul_checkout) return
        this.has_opened_jokul_checkout = true
        this.openJokulCheckout()
      },
      openJokulCheckout(){
        this.is_opening_jokul_checkout = true
        this.$openJokulCheckout(this.jokulCheckoutUrl).finally(()=>{
          this.is_opening_jokul_checkout = false
        })
      },
      checkPaymentStatus(load=true,res){
        this.error = false
        if(load) this.btn_is_load = true
        post("CORE","tx-check-payment",{
          tx_id: this.order_detail.tx_order_id
        }).then(response=>{
          if(response.data.success){
            this.$router.push({
              path:'/'+this.getMerchant().code+'/payment-result/'+this.order_detail.tx_order_id
            })
          }else{
            this.error = true
          }
          if(load) this.btn_is_load = false
        })
      }
    }
  }

</script>
<style scoped>
  input {
    border: none;
    border-radius: 0px !important;
    border-bottom: 1px solid #0000001A;
  }

  .circle-cart {
    border-radius: 100%;
    width: 26px;
    height: 26px;
    padding: 3px 6px;
  }

  .opacity-45 {
    color: #b5cc92 !important;
  }

  .bg-green-opacity {
  	background-color: #b5cc92 !important;
  }

  .desh-cart {
    position: relative;
    top: -5px;
  }

  .text-light-bold {
    color: #414955A6 !important;
  }

  .bg-smoth-light {
    background-color: #FAFAFC;
  }

  .rounded-bottom-10 {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .rounded-top-10 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .color-black {
    color: #000 !important
  }

  .box-shadow-bottom-bold {
    box-shadow: 0px 9px 11px 0px hsla(0, 0%, 73%, 0.24);
  }

  

</style>



// WEBPACK FOOTER //
// src/pages/ticket/PaymentForm.vue